'use client'
import { ReviewRoomGroup } from '@/src/types/hotels/details'
import { useTranslations } from 'next-intl'
import { useMemo, useState } from 'react'
import RoomSelectionSection from './roomSelectionSection'
import { ReviewContext } from '../roomVariantRow'

type RoomFilter = 'roomOnly' | 'hotDeals'

export interface RoomSelectionSectionContainerProps {
    roomGroups: ReviewRoomGroup[]
    variant: 'mobile' | 'desktop'
    reviewContext: ReviewContext
    onSelect: (rId: string, arNo: string) => void
}

// Logic layer: room filter state + filtering. Filtering keeps the group→options nesting,
// dropping any group left with no matching options (RN SelectRoomTab parity).
const RoomSelectionSectionContainer = ({ roomGroups, variant, reviewContext, onSelect }: RoomSelectionSectionContainerProps) => {
    const t = useTranslations('hotels')
    const [filters, setFilters] = useState<Record<RoomFilter, boolean>>({ roomOnly: false, hotDeals: false })

    const toggle = (key: string) => setFilters(prev => ({ ...prev, [key]: !prev[key as RoomFilter] }))

    const filteredGroups = useMemo(() => {
        if (!filters.roomOnly && !filters.hotDeals) return roomGroups
        return roomGroups
            .map(group => ({
                ...group,
                options: group.options.filter(option => {
                    if (filters.roomOnly && option.mealKind !== 'roomOnly') return false
                    if (filters.hotDeals && !option.isHotDeal) return false
                    return true
                })
            }))
            .filter(group => group.options.length > 0)
    }, [roomGroups, filters])

    const chips = [
        { key: 'roomOnly', label: t('filterRoomOnly'), active: filters.roomOnly },
        { key: 'hotDeals', label: t('filterHotDeals'), active: filters.hotDeals }
    ]

    return (
        <RoomSelectionSection
            filterRoomsByLabel={t('filterRoomsBy')}
            chips={chips}
            onToggleFilter={toggle}
            filteredGroups={filteredGroups}
            variant={variant}
            noRoomsLabel={t('noRoomsAvailable')}
            reviewContext={reviewContext}
            onSelect={onSelect}
        />
    )
}

export { RoomSelectionSectionContainer }
export default RoomSelectionSectionContainer
